import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { LookupGetService } from '../../../service/lookup-service/lookup-get.service';
import { LoggerService } from '../../../service/logger-service/logger.service';

//const MAX_WIDTH = 1000;
//const MIN_WIDTH = 244.6;

@Component({
  selector: 'app-condition-query-select-type',
  templateUrl: './condition-query-select-type.component.html',
  styleUrl: './condition-query-select-type.component.scss'
})
export class ConditionQuerySelectTypeComponent extends FieldType {
  
  isChecked: boolean = false;
  results: any = [];
  style: any = {'height': '37.6px'};

  constructor(
    public lookupService: LookupGetService,
    private loggerService: LoggerService
  ) {
    super();
  }

  ngOnInit() {
    if (this.formControl.value) {
      this.loadLookup();
      this.isChecked = true;
    } else {
      this.loadLookup();
      this.isChecked = false;
    }
  }

  manageCheck() {
    if (this.isChecked) {
      this.isChecked = !this.isChecked;
      if (!this.isChecked) {
        this.formControl.setValue(null);
      }
    }
  }

  loadLookup() {
    const lookup = this.field.props!['lookup'];
    if (this.results.length == 0) {
      this.lookupService.loadCachedOptions(lookup).subscribe(
        data => {
          this.results = data;
        },
        error => {
          this.loggerService.err('Error loading options', error);
        }
      );
    }
  }

  onInputChange() {
    if (this.formControl.value) {
      this.isChecked = true;
      this.props['isModified'] = true;
      this.props['defaultValue'] = this.formControl.value;
    } else {
      this.isChecked = false;
      this.props['isModified'] = false;
      this.props['defaultValue'] = null;
    }
  }
}
